import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CAMERA_FACING_MODE } from "../../../../constants/CallSettingConstants";
import { checkDeviceHasCamIssue } from "../../../../shared/utility";
import { setIsFrontCameraSelected, setWorkingCam } from "../../../../reducers/call-setting-reducer";
import { addVideoParams, publishVideo, unpublishVideo } from "../../../Twilio/VideoCall/VideoUtils";
import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import { DEVICE_TYPES } from "../../../../constants/Constants";
import flashService from "../../../../services/flashService";
import { restartLocalVideoTracks } from "../../../Twilio/twilioCallUtility";
import { LogFirebase } from "../../../../services/firestore";

const FlipCamera = () => {
    const { isFrontCameraSelected } = useSelector((state) => state.callSetting);
    const dispatch = useDispatch();

    const handleFlipCamera = async () => {
        const facingMode = isFrontCameraSelected ? CAMERA_FACING_MODE.BACK : CAMERA_FACING_MODE.FRONT;
        LogFirebase("FlipCamera", "isFrontCameraSelected", isFrontCameraSelected);
        LogFirebase("FlipCamera", "facingMode", facingMode);

        if (!checkDeviceHasCamIssue()) {
            setTimeout(() => {
                dispatch(setIsFrontCameraSelected(!isFrontCameraSelected));
                const videoParams = addVideoParams("flipCamera");
                dispatch(setWorkingCam(false));
                restartLocalVideoTracks(videoParams).then(function () {
                    if (
                        GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.ANDROID_BROWSER ||
                        GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.IOS_BROWSER
                    ) {
                        flashService.handleFlashTrack();
                    }
                });
            }, 100);
        } else {
            //old flow for note 10+ & S20 plus
            unpublishVideo();
            dispatch(setIsFrontCameraSelected(!isFrontCameraSelected));
            setTimeout(() => {
                publishVideo("flipCamera");
            }, 100);
        }
    };

    return (
        <div className='topbar-button'>
            <div className='button custom-tooltip tooltip-auto-width'>
                <button className='btn topbar-btn' onClick={handleFlipCamera}>
                    <span className='for-icon icon-flip-camera'></span>
                </button>
            </div>
        </div>
    );
};

export default FlipCamera;
